export const PAGES = ['Words', 'Notes', 'Collections', 'Activity'] as const;
